<script lang="ts">
    import { onDestroy } from "svelte";
    import {
        getItemsListManager,
        getItemsListManagerState,
    } from "./ItemsListManager";

    const state = getItemsListManagerState();
    const manager = getItemsListManager();

    let container: HTMLElement;

    function onItemClicked(event: Event) {
        const itemIndex = parseInt(
            (event.currentTarget as HTMLElement).dataset["itemindex"] || ""
        );
        if (itemIndex >= 0) {
            manager.selectItem(itemIndex);
        }
    }

    const stateSubscription = state.subscribe(() => {
        setTimeout(() => {
            if (!container) {
                return;
            }
            const elementToScroll =
                container.getElementsByClassName("scrollIntoView");
            if (elementToScroll.length > 0) {
                elementToScroll[0].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                });
            }
        });
    });
    onDestroy(stateSubscription);
</script>

<ul bind:this={container}>
    {#if $state && $state.totalItems === 0}
        <li class="uppercase text-gray-500 text-xs py-2" />
    {/if}
    {#if $state && $state.groups}
        {#each $state.groups as group}
            {#if group.label}
                <li class="uppercase text-gray-500 text-xs py-2 ">
                    {group.label}
                </li>
            {/if}
            {#each group.items as item}
                <li
                    class:active={item.itemIndex === $state.activeIndex}
                    class:scrollIntoView={item.itemIndex === $state.activeIndex}
                    class="hover:bg-gray-100 transition-all duration-300"
                >
                    <button
                        on:click={onItemClicked}
                        class="focus:outline-none py-1 block w-full h-full text-align-inherit"
                        data-itemindex={item.itemIndex}
                    >
                        <slot
                            item={item.data}
                            itemIndex={item.itemIndex}
                            active={item.itemIndex === $state.activeIndex}
                        />
                    </button>
                </li>
            {/each}
        {/each}
    {/if}
</ul>
